import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { MessageCircle, Quote } from "lucide-react";
import { api, waLink } from "@/lib/api";

export default function Founder() {
  const [f, setF] = useState(null);
  useEffect(() => { api.get("/founder").then((r) => setF(r.data)).catch(() => {}); }, []);
  if (!f?.story) return null;
  return (
    <section id="founder" className="py-16 lg:py-24 bg-surface overflow-hidden" data-testid="founder-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-14 items-center">
        <motion.div initial={{ opacity: 0, x: -30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.8 }} className="lg:col-span-7 relative">
          <div className="rounded-[2rem] overflow-hidden shadow-2xl shadow-ink/20 aspect-[3/2]">
            <img src={f.photo} alt={`${f.name}, ${f.title} of Random Rider, on Puri Marine Drive`} loading="lazy" className="w-full h-full object-cover" data-testid="founder-photo" />
          </div>
          <div className="absolute -bottom-4 left-6 sm:left-10 bg-ink text-sand rounded-2xl px-5 py-3 shadow-lg" data-testid="founder-badge">
            <p className="font-serif text-lg font-bold leading-tight" data-testid="founder-name">{f.name}</p>
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-gold">{f.title} · Puri</p>
          </div>
        </motion.div>
        <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.8, delay: 0.15 }} className="lg:col-span-5 pt-6 lg:pt-0">
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-terra mb-3">Meet the founder</p>
          <h2 className="font-serif text-3xl sm:text-4xl font-bold text-ink leading-tight">The rider behind <span className="text-terra italic">Random Rider</span></h2>
          <Quote size={28} className="text-terra/40 mt-6" />
          <p className="mt-2 text-base text-ink/75 leading-relaxed" data-testid="founder-story">{f.story}</p>
          <a href={waLink(`Hi ${f.name.split(" ")[0]}! I found Random Rider online and want to plan a ride in Puri.`)} target="_blank" rel="noreferrer" data-testid="founder-whatsapp-button"
            className="mt-7 inline-flex items-center gap-2 bg-ink text-sand text-sm font-semibold px-6 py-3 rounded-full hover:bg-terra transition-colors">
            <MessageCircle size={15} /> Say hi on WhatsApp
          </a>
        </motion.div>
      </div>
    </section>
  );
}
